import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import './animated-text.less';

export const AnimatedText = ({
  text,
  letterDelay = 0.1,
  animationDuration = 1,
  scaleValues = {
    initial: 0,
    peak: 1.3,
    dip: 0.85,
    bounce: 1.05,
    final: 1,
  },
  wordClassName,
  letterClassName,
}) => {
  const className = useClassName('AnimatedText');

  if (!text) return null;

  const words = text.split(' ');
  let globalLetterIndex = 0;

  return (
    <>
      {words.map((word, wordIndex) => {
        return (
          <span
            key={`word-${wordIndex}`}
            className={`${className('word')} ${wordClassName || ''}`}>
            {word.split('').map((letter, letterInWordIndex) => {
              const currentIndex = globalLetterIndex++;
              return (
                <span
                  key={`letter-${wordIndex}-${letterInWordIndex}`}
                  className={`${className('word__letter')} ${
                    letterClassName || ''
                  }`}
                  style={{
                    animationDelay: `${currentIndex * letterDelay}s`,
                    '--animation-duration': `${animationDuration}s`,
                    '--scale-initial': scaleValues.initial,
                    '--scale-peak': scaleValues.peak,
                    '--scale-dip': scaleValues.dip,
                    '--scale-bounce': scaleValues.bounce,
                    '--scale-final': scaleValues.final,
                  }}>
                  {letter}
                </span>
              );
            })}
            {wordIndex < words.length - 1 && (
              <span
                className={`${className('word__letter')} ${
                  letterClassName || ''
                }`}
                style={{
                  animationDelay: `${globalLetterIndex++ * letterDelay}s`,
                  '--animation-duration': `${animationDuration}s`,
                  '--scale-initial': scaleValues.initial,
                  '--scale-peak': scaleValues.peak,
                  '--scale-dip': scaleValues.dip,
                  '--scale-bounce': scaleValues.bounce,
                  '--scale-final': scaleValues.final,
                }}>
                {'\u00A0'}
              </span>
            )}
          </span>
        );
      })}
    </>
  );
};

AnimatedText.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  letterDelay: PropTypes.number,
  animationDuration: PropTypes.number,
  scaleValues: PropTypes.shape({
    initial: PropTypes.number,
    peak: PropTypes.number,
    dip: PropTypes.number,
    bounce: PropTypes.number,
    final: PropTypes.number,
  }),
  wordClassName: PropTypes.string,
  letterClassName: PropTypes.string,
};

AnimatedText.defaultProps = {
  text: '',
  className: '',
  letterDelay: 0.1,
  animationDuration: 1,
  scaleValues: {
    initial: 0,
    peak: 1.3,
    dip: 0.85,
    bounce: 1.05,
    final: 1,
  },
  wordClassName: '',
  letterClassName: '',
};
